import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { ListView as NativeListView } from 'react-native';
import { View } from '@dbk/ui-react-utils';

import Text from '../text';
import ListViewRow from './list-view-row';

import styles from './list-view.styles';

class ListViewDataSource extends NativeListView.DataSource {
  constructor() {
    super({
      rowHasChanged: (row1, row2) => row1 !== row2,
    });
  }
}

class ListView extends PureComponent {
  static propTypes = {
    rows: PropTypes.array,
    renderRow: PropTypes.func,
    testID: PropTypes.string,
    removeClippedSubviews: PropTypes.bool,
    fullWidthSeparator: PropTypes.bool,
  };

  static defaultProps = {
    testID: 'list-view',
    removeClippedSubviews: true,
    fullWidthSeparator: false,
  };

  constructor(props) {
    super(props);

    this.state = this.getComponentState(props);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this.getComponentState(nextProps));
  }

  getComponentState(props) {
    const { rows = [] } = props;
    return {
      dataSource: new ListViewDataSource().cloneWithRows(rows),
    };
  }

  render() {
    const { renderRow, testID, removeClippedSubviews } = this.props;
    return (
      <NativeListView
        enableEmptySections
        style={styles.root}
        testID={testID}
        dataSource={this.state.dataSource}
        renderRow={renderRow}
        removeClippedSubviews={removeClippedSubviews}
      />
    );
  }
}

function RowSeparator({ fullWidth }) {
  return (
    <View style={fullWidth ? {} : styles.rowSeparator}>
      <View style={styles.rowBorder} />
    </View>
  );
}
RowSeparator.propTypes = {
  fullWidth: PropTypes.bool,
};
RowSeparator.defaultProps = {
  fullWidth: false,
};

function RowGroupHeader({ text }) {
  return (
    <View style={styles.rowGroupRoot}>
      <View style={styles.rowGroupWrapper}>
        <Text size="small" style={styles.rowGroupText}>{text}</Text>
      </View>
    </View>
  );
}
RowGroupHeader.propTypes = {
  text: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
};

ListView.Row = ListViewRow;
ListView.RowSeparator = RowSeparator;
ListView.RowGroupHeader = RowGroupHeader;

export default ListView;
